import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './style.css';

const Tooltip = ({ offset, className, children }) => {
  const [isActive, setIsActive] = useState(false);
  const tooltip = useRef(null);

  const handleTrigger = () => {
    setIsActive(!isActive);
  };

  const handleClickOutside = (event) => {
    if (tooltip.current && !tooltip.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${className} tooltip ${offset !== 0 ? `offset${offset}` : ''} ${isActive ? 'active' : ''}`}
      ref={tooltip}
    >
      <div
        className="trigger"
        onClick={handleTrigger}
      />
      <div
        className="card"
        onClick={handleTrigger}
      >
        <p className="tooltipContent">{children}</p>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  offset: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
  offset: 0,
  className: '',
};

export default Tooltip;
